import { Alert, Modal, Tabs } from '@drip/drip-design';
import React, { useState } from 'react';
import DistributeForm from './distribute-form';
import DistributeList from './distribute-list';
import './index.less';

function AuthDistribute(props: any) {
  const { id, isPartner } = props;
  const [visible, setVisible] = useState(false);
  const [actKey, setActKey] = useState('1');

  let btn = React.cloneElement(props.children, {
    onClick: () => setVisible(true),
  });

  const onTabChange = (activeKey: string) => {
    setActKey(activeKey);
  };

  const onCancel = () => {
    setVisible(false);
  };

  const alert = (
    <Alert
      showIcon
      type="info"
      message={
        <div>
          <div>协作者：拥有添加申请者权限/发起黑白名单申请的权限（如：事业部营销，作战单元负责人）</div>
          <div>申请者：仅拥有发起白名单申请的权限（如：采销）</div>
        </div>
      }
    />
  );

  return (
    <>
      {btn}
      <Modal
        className="auth-distribute"
        visible={visible}
        title="权限分配"
        footer={null}
        onCancel={onCancel}
        width={800}
      >
        <Tabs onChange={onTabChange} activeKey={actKey}>
          <Tabs.TabPane tab="分配" key="1">
            {alert}
            <DistributeForm onCancel={onCancel} id={id} isPartner={isPartner} />
          </Tabs.TabPane>
          <Tabs.TabPane tab="已分配" key="2">
            {alert}
            <DistributeList id={id} needFresh={actKey === '2'} isPartner={isPartner} />
          </Tabs.TabPane>
        </Tabs>
      </Modal>
    </>
  );
}

export default AuthDistribute;
